import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Button } from '@poliedro/tamentai';

import { resetProfile } from '../../store/profileSlice';
import { ErrorPageIcon } from './icon';
import { ButtonsWrapper, Container, Content, Subtitle, Title } from './styles';

const ErrorPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleRetry = () => {
    const retryToken = sessionStorage.getItem('auth_retry_token');

    if (retryToken) {
      const normalized = retryToken.trim();
      sessionStorage.removeItem(`auth_validation_lock:${normalized}`);
      localStorage.setItem('token', normalized);
      sessionStorage.removeItem('auth_retry_token');
    }
    window.location.replace('/');
  };

  const goPmais = () => {
    localStorage.removeItem('token');
    dispatch(resetProfile());
    window.location.href = `${import.meta.env.VITE_PMAIS_URL}`;
  };

  return (
    <Container>
      <Content>
        <ErrorPageIcon />
        <Title>
          Ops! Alguma coisa <br />
          deu errado.
        </Title>
        <Subtitle>
          O Cosmos está em manutenção no momento. <br />
          Em breve, estará novamente disponível.
        </Subtitle>
        <ButtonsWrapper>
          <Button size="lg" variant="primary" onClick={handleRetry}>
            Tentar novamente
          </Button>
          <Button size="lg" variant="primary" onClick={goPmais}>
            Ir para o P+
          </Button>
        </ButtonsWrapper>
      </Content>
    </Container>
  );
};

export default ErrorPage;
